import IMessage from "../../../interfaces/message.interface";

export const MESSAGE_SUCCESS: IMessage = {
    textMessage: "Respuesta guardada",
    style: "success",
    open: '',
    duration: 3000
}

export const MESSAGE_ERROR: IMessage = {
    textMessage: "Hubo un error, intenta nuevamente más tarde",
    style: "danger",
    open: '',
    duration: 3000
}